import React from 'react';
import amenities from '../../assests/img/amenities.jpg';

const Amenities = () => {

    return (
        <>
            <div className='inner_top_about_us'>
                <div id="bg" className="data-typography-1 data-theme-1">
                    <div className="page-wraper">
                        <div className="page-content bg-white">
                            <div className="dz-bnr-inr dz-bnr-inr-sm style-1 text-center overlay-primary-dark">
                                <div className="coustom_container">
                                    <div className="dz-bnr-inr-entry">
                                        <div className="pheading">
                                            <h1>Amenities</h1>
                                        </div>
                                        <nav aria-label="breadcrumb" className="breadcrumb-row">
                                            <ul className="breadcrumb">
                                                <li className="breadcrumb-item">
                                                    <a href="/">Home</a>
                                                </li>
                                                <li className="mx-2">
                                                    /
                                                </li>
                                                <li className="breadcrumb-item active" aria-current="page">
                                                    Amenities
                                                </li>
                                            </ul>
                                        </nav>
                                    </div>
                                </div>
                            </div>


                            <section className="content-inner section-wrapper5 pt-5 pb-5">
                                <div className="coustom_container">
                                    <div className="row">
                                        <div
                                            className="col-xl-9 col-lg-6 m-b30 wow fadeInUp"
                                            data-wow-delay="0.4s"
                                        >
                                            <div id="pagedata" className="pagedata">
                                                <p style={{ textAlign: "justify" }}>
                                                    <img src={amenities} alt="amenities" width="100%" />
                                                </p>
                                                <ul>
                                                    <li>Open and spacious Green Campus</li>
                                                    <li>Safe and secure campus with complete CCTV monitoring</li>
                                                    <li>Full power backup</li>
                                                    <li>RO Filtered drinking water with water cooler</li>
                                                    <li>Naturally lit, well ventilated and commodious classroom around central</li>
                                                    <li>courtyard</li>
                                                    <li>Smart classroom</li>
                                                    <li>Modern and Ergonomic classroom furniture</li>
                                                    <li>Interactive, educative and soft floor classrooms for preschoolers</li>
                                                    <li>Student Lockers</li>
                                                    <li>Books and Magazine shelf with dedicated reading area in each classroom</li>
                                                    <li>Computer lab</li>
                                                    <li>Science lab</li>
                                                    <li>Language lab</li>
                                                    <li>Library</li>
                                                    <li>Activity Room</li>
                                                    <li>Activity Room</li>
                                                    <li>Activity Room</li>
                                                    <li>Transportation facility</li>
                                                    <li>Large Playground</li>
                                                    <li>Indoor games</li>
                                                    <li>Open Gym</li>
                                                    <li>Separate playground for junior and senior students</li>
                                                    <li>Large sand-pit area</li>
                                                    <li>Dedicated play area for kids stimulating psychomotor activity</li>
                                                </ul>
                                            </div>
                                        </div>

                                        <div
                                            className="col-xl-3 col-lg-6 wow fadeInUp"
                                            data-wow-delay="0.2s"
                                        >
                                            <div className="bg-lgrey">
                                                <div className="subMenubg active">
                                                    <a href="spiritual-care-and-wellbeing" target="_self" className="submenu">
                                                        Spiritual care and Wellbeing
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="academic-life"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Academic Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="sporting-life" target="_self" className="submenu">
                                                        Sporting Life
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="co-curricular" className="submenu">
                                                        Co-curricular
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a href="social-responsibility" target="_self" className="submenu">
                                                        Social Responsibility
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="activities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Activities
                                                    </a>
                                                </div>
                                                <div className="subMenubg">
                                                    <a
                                                        href="amenities"
                                                        target="_self"
                                                        className="submenu"
                                                    >
                                                        Amenities
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>

                        {/* <button className="scroltop icon-up" type="button">
                            <i className="fas fa-arrow-up"></i>
                        </button> */}
                    </div>
                </div>
            </div >
        </>
    )
}

export default Amenities;